import React, { useState } from "react";
import { message, Button, Drawer, Space, Input, Divider, Skeleton } from "antd";
const { TextArea } = Input;

import PropTypes from "prop-types";
import { Contacts, SearchCompanyEntity } from "./components";
import { admitedEntities } from "./utils";
import { CircleAnimationCompact } from "../loading";

const emptyEntity = {
	company_id: "",
	entity_company_id: "",
	name: "",
	description: "",
	address: "",
	state: "active",
	contacts: [],
};

export const AddEntityDrawer = ({
	token, 
	company_id, 
	entities, 
	openAddClient, 
	onOpenAddClient, 
	addNewClient,
	entitySelected,
}) => {	
	if(!admitedEntities[entitySelected]){
		message.error("Error del Developer: Entidad ingresada en el componente es invalida");
		return <></>;
	}

	const [client, setClient] = useState(emptyEntity);
	const [companyEntity, setCompanyEntity] = useState(null);
	
	const { description, contacts } = client;
			
	const [valid, setValid] = useState(false);
	
	const [loading, setLoading] = useState(false);
			
	const createClient = async() => {
		setLoading(true);

		const data = {
			company_id,
			entity_company_id: companyEntity?.id ? companyEntity?.id : "",
			description,
			address: companyEntity?.address,
			contacts,
			newCompanyData: companyEntity?.id ? null : companyEntity
		};

		const extraData = {
			entity_company_tid: companyEntity.tid,
			name: companyEntity.name,
			state: "active",
		};
		//const response = await edit_entity(token, "create", data, "clients");

		const response = await addNewClient(data, extraData);
	
		if(response){
			//message.success(`${admitedEntities[entitySelected].single} creado con exito!`);
			message.success("¡Cliente creado con exito!");
			//const { id, entity_company_id } = response;
			//const newClient = {
			//	...client,
			//	id,
			//	company_id,
			//	entity_company_id,
			//	entity_company_tid: companyClient.tid,
			//	name: companyClient.name,
			//	address: companyClient.address
			//};

			//onNewClient(newClient);
			onOpenAddClient(false);
			// Clean Data
			setValid(false);
			setClient(emptyEntity);
			setCompanyEntity(null);
		}
				
		setLoading(false);
	};
		
	return (
		<Drawer
			title={`Agregar ${admitedEntities[entitySelected].single}`}
			placement="right"
			width={"60vw"}
			onClose={() => onOpenAddClient(false)}
			open={openAddClient}
			extra={
				<Space>
					<Button 
						type="primary" 
						disabled={
							(
								!valid || 
								contacts.length === 0 || 
								companyEntity?.name.trim() === "" || 
								companyEntity?.address.trim() === "" || 
								companyEntity?.country?.trim() === ""
							)
						}
						onClick={createClient}
						loading={loading}
					>
						Crear
					</Button>
				</Space>
			}
		>
			<SearchCompanyEntity
				token={token}
				entities={entities}
				loading={loading}
				onLoading={(value) => setLoading(value)}
				onValid={(value) => setValid(value)}
				onCompanyData={(value) => setCompanyEntity(value)}
				entitySelected={entitySelected}
			/>

			{/*SHOW REST OF INFORMATION TO FILL*/}
			{
				loading &&
				<CircleAnimationCompact/>
			}
			{valid && <Skeleton loading={loading}>
				<Divider orientation="center">Datos a insertar para el nuevo {admitedEntities[entitySelected].single}</Divider>			
				<h3>Descripcion: </h3>
				<TextArea
					value={description}
					onChange={(e) => setClient({...client, description: e.target.value})}
					placeholder="Ingresa una descripcion..."
					autoSize={{
						minRows: 3,
						maxRows: 5,
					}}
					style={{
						marginBottom: "20px",
					}}
				/>								
				<Contacts
					contacts={contacts}
					onChangeContacts={value => setClient({...client, contacts: value})}
				/>					
			</Skeleton>}				
		</Drawer>
	);
};

AddEntityDrawer.propTypes = {
	token: PropTypes.string.isRequired,
	company_id: PropTypes.string.isRequired,
	entities: PropTypes.array.isRequired,
	openAddClient: PropTypes.bool.isRequired,
	onOpenAddClient: PropTypes.func.isRequired,
	addNewClient: PropTypes.func.isRequired,
	entitySelected: PropTypes.string.isRequired,
};